// @core/api/endpoints/authn/exchange_device_token.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExchangeDeviceTokenRequest,
  TokenResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Exchange device code for tokens
 * Polls for completion of the device authorization flow. Returns tokens once the user has authorized the device, or an error indicating the request is still pending.
 * @public This endpoint does not require authentication
 */
export async function ExchangeDeviceToken(
  data: ExchangeDeviceTokenRequest,
  options?: RequestOptions
): Promise<TokenResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/device/token`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TokenResponse>(requestPath, data, requestOptions);
}
